/**
 * Helper minimalista para concatenar clases condicionales.
 * Acepta strings, arrays, objetos {clase: bool}.
 * Filtra falsy. No dedupe.
 *
 *   cn('btn', isActive && 'active', { 'opacity-50': disabled })
 */
export const cn = (...args) => {
    const out = [];
    const push = (v) => {
        if (!v) return;
        if (typeof v === 'string') { out.push(v); return; }
        if (Array.isArray(v)) { v.forEach(push); return; }
        if (typeof v === 'object') {
            for (const k in v) if (v[k]) out.push(k);
            return;
        }
    };
    args.forEach(push);
    return out.join(' ');
};

export default cn;
